import TreeNodeModel from 'models/TreeNode';
import { observable, computed } from 'mobx';
import { serialize, deserialize } from 'serializers/GngNode';

export default class GngNode extends TreeNodeModel {

  @observable id
  @observable parentId
  @observable code
  @observable description
  @observable fromDate
  @observable toDate
  @observable iscode
  @observable level
  @observable ettClass

  @computed get store() {
    return this.rootStore.gngTreeStore;
  }

  parse(json) {
    return deserialize(json);
  }

  toJSON() {
    return serialize(this);
  }

}



// WEBPACK FOOTER //
// ./src/models/GngNode.js